import $ from 'jquery'
import 'magnific-popup'
import domReady from '../utils/domReady.js'

const magnificEvents = () => {
  $('body').magnificPopup({
    delegate: 'a.image-pop',
    type: 'image',
    tLoading: 'Loading image #%curr%...',
    fixedContentPos: true,
    mainClass: 'mfp-fade mfp-img-mobile',
    gallery: {
      enabled: true,
      navigateByImgClick: true,
      preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
    },
    zoom: {
      enabled: false,
      duration: 300, // don't foget to change the duration also in CSS
      opener: function (element) {
        return element.find('img')
      }
    },
    image: {
      tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
      titleSrc: function (item) {
        return item.el.attr('title')
      }
    }
  })

  if (typeof galleryData === 'object' && galleryData !== null) {
    if (Object.keys(galleryData).length === 0) {
      console.warn('magnific.js: galleryData is empty, gallery zoom disabled')
    }
    $('.show-zoom-icon').each(function () {
      const $this = $(this)
      const index = $this.data('index')

      $this.magnificPopup({
        index: parseInt(index, 10),
        key: 'my-popup',
        mainClass: 'mfp-object-viewer',
        items: galleryData,
        type: 'inline',
        inline: {
          markup: '<div class="collections-popup" data-theme="dark" data-text-theme="light"><div class="mfp-return"><p>&laquo;&nbsp;Return to ' + pageTitle + '</p></div><div class="mfp-close"></div><div class="popup-wrapper">' +
            '<div class="image-wrapper"><div class="mfp-objImg"></div><ul class="mfp-objLink social-actions"></ul></div>' +
            '<div class="content-wrapper">' +
              '<div class="mfp-objTitle"></div>' +
              '<div class="mfp-objDate"></div>' +
              '<div class="mfp-objCountry"></div>' +
              '<div class="mfp-objChat"></div>' +
              '<a class="mfp-objCollectionLink" target="_blank">View Object Record</a>' +
              '</div>' +
          '</div></div>'
        },
        allowHTMLInTemplate: true,
        gallery: {
          enabled: true
        }
      })

      $(document).on('click', '.mfp-return', function () {
        $this.magnificPopup('close')
      })
    })

    $(window).on('hashchange', function () {
      if (location.href.indexOf('#detail') < 0) {
        $.magnificPopup.close()
      }
    })
  } else if (document.querySelector('.show-zoom-icon')) {
    console.warn('magnific.js: .show-zoom-icon elements found but galleryData is not defined')
  }
}

domReady(() => {
  magnificEvents()
})
